import _asyncToGenerator from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import env from '@tencent/vft-common/env'; // eslint-disable-next-line import/extensions

import atom from '@tencent/vft-atom';
import { MatchService } from '@/service';
import { playCidVideo } from '@/util';
var _window = window,
    TencentSports = _window.TencentSports;
var _window$setting$观赛日历 = window.setting.观赛日历,
    赛程列表 = _window$setting$观赛日历.赛程列表,
    冬奥会今日看点列表 = _window$setting$观赛日历.冬奥会今日看点列表,
    NBA今日看点配置 = _window$setting$观赛日历.NBA今日看点配置;
export default {
  data: function data() {
    return {
      tab: 'owg',
      videoList: {
        nba: [],
        owg: 冬奥会今日看点列表
      }
    };
  },
  computed: {
    // 当前的文章流列表
    curVideoList: function curVideoList() {
      var _this$videoList$this$;

      // 过滤不含vid的视频
      // nba 取 data.vid, 冬奥会魔方配置取 vid
      return (_this$videoList$this$ = this.videoList[this.tab]) === null || _this$videoList$this$ === void 0 ? void 0 : _this$videoList$this$.filter(function (v) {
        return v.vid;
      });
    },
    // 是否选中 nba tab
    isNbaTab: function isNbaTab() {
      return this.tab === 'nba';
    },
    // 是否展示预约btn，只有在腾讯视频内展示
    isShowAppointBtn: function isShowAppointBtn() {
      return (env.isApp || env.isQQSports) && this.isNbaTab;
    },
    // 赛程配置文件
    scheduleConfig: function scheduleConfig() {
      return 赛程列表[this.isNbaTab ? 'NBA' : '冬奥会'];
    }
  },
  watch: {
    tab: {
      handler: function handler() {
        if (this.isNbaTab) {
          this.getNbaArticleList();
        }
      },
      immediate: true
    }
  },
  methods: {
    playCidVideo: playCidVideo,
    // 查询频道信息
    getNbaArticleList: function getNbaArticleList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$curVideoList;

        var _yield$MatchService$g, ret, msg, _yield$MatchService$g2, status, statusMsg, modList, list;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(((_this$curVideoList = _this.curVideoList) === null || _this$curVideoList === void 0 ? void 0 : _this$curVideoList.length) > 0)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return MatchService.getNbaArticleList(NBA今日看点配置);

              case 4:
                _yield$MatchService$g = _context.sent;
                ret = _yield$MatchService$g.ret;
                msg = _yield$MatchService$g.msg;
                _yield$MatchService$g2 = _yield$MatchService$g.data;
                _yield$MatchService$g2 = _yield$MatchService$g2 === void 0 ? {} : _yield$MatchService$g2;
                status = _yield$MatchService$g2.status, statusMsg = _yield$MatchService$g2.statusMsg, modList = _yield$MatchService$g2.modList;

                if (!(ret !== 0 || status !== 0)) {
                  _context.next = 13;
                  break;
                }

                _this.toast("[".concat(status || ret, "]").concat(statusMsg || msg));

                return _context.abrupt("return");

              case 13:
                list = (modList === null || modList === void 0 ? void 0 : modList.length) > 0 ? modList[0].list : [];
                _this.videoList[_this.tab] = list.map(function (v) {
                  return v.data;
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // app 内打开
    openAppChannel: function openAppChannel() {
      if (env.isQQSports) {
        var subTab = this.isNbaTab ? '100000' : '100500';
        TencentSports.appSdk.openJumpData({
          type: 5,
          param: {
            tab: '0',
            subTab: subTab
          }
        });
      } else {
        var url = this.isNbaTab ? 'txvideo://v.qq.com/HomeActivity?channelId=100176&tabIndex=0' : 'txvideo://v.qq.com/HomeActivity?channelId=700013&tabIndex=0';
        this.openUrl(url);
      }
    },
    // 腾讯视频内接口预约
    appoint: function appoint() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var list;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                list = _this2.scheduleConfig.配置列表.map(function (v) {
                  return v.pid;
                }).filter(function (v) {
                  return !!v;
                });
                _context2.prev = 1;
                _context2.next = 4;
                return MatchService.attent(list);

              case 4:
                _this2.toast('预约成功，比赛开始将通过APP消息通知到你');

                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](1);
                console.log(_context2.t0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 7]]);
      }))();
    },
    // 日历点击
    handleCalendarClick: function handleCalendarClick(item) {
      console.log(item);
      if (!item) return;

      if (this.isNbaTab) {
        // app内
        if (env.isApp && item.pid) {
          var schemalUrl = "txvideo://v.qq.com/TencentLiveActivity?pid=".concat(item.pid);
          atom.openUrl(schemalUrl);
        } else if (env.isQQSports && item.mid) {
          TencentSports.appSdk.openJumpData({
            type: 105,
            param: {
              mid: item.mid
            }
          });
        }
      } else {
        this.playCidVideo(item);
      }
    },
    // 去往预约页面
    gotoAppointPage: function gotoAppointPage() {
      if (this.isShowAppointBtn) {
        if (env.isApp) {
          this.openUrl('https://sports.qq.com/kbsweb/qb/leagues.htm#/100000/schedule');
        } else if (env.isQQSports) {
          TencentSports.appSdk.openJumpData({
            type: 103,
            param: {
              cateColumnId: 100000,
              cateId: 2,
              competitionName: 'NBA',
              isRank: 0
            }
          });
        }
      } else {
        this.openAppChannel();
      }
    }
  }
};